import { ParentCategory } from '../interfaces/categories.interface';
import { CategoriesEnumList } from '../enums/settings-categories.enum';
import { CategoriesColumnConfig } from '../interfaces/column-config.interface';
import { BASE_CELL_CLASS, BASE_HEADER_CLASS } from './table-style.constants';

export const CATEGORY_SETTINGS = {
  pageSizes: [5, 10, 25, 50],
  itemsPerPage: 10,
  currentPage: 1,
};

export const PARENT_CATEGORIES: ParentCategory[] = [
  { id: 1, name: 'No category' },
  { id: 2, name: 'Fashion, Clothing & Accessories' },
  { id: 3, name: 'Electronics & Gadgets' },
  { id: 4, name: 'Home Furnishing & Decor' },
  { id: 5, name: 'Grocery & Consumables' },
  { id: 6, name: 'Sports & Outdoor Equipment' },
  { id: 7, name: 'Beauty & Cosmetics' },
];

export const FAKE_CATEGORIES_QUANTITY = 5;
const CATEGORIES_TABLE_TRANSLATION_KEY = 'shop-settings.categories.table';

export const CATEGORIES_COLUMNS_CONFIG: readonly CategoriesColumnConfig[] = [
  {
    name: CategoriesEnumList.CATEGORY,
    label: `${CATEGORIES_TABLE_TRANSLATION_KEY}.category`,
    headerClass: `${BASE_HEADER_CLASS} ${BASE_HEADER_CLASS}--category`,
    cellClass: BASE_CELL_CLASS,
  },
  {
    name: CategoriesEnumList.URL,
    label: `${CATEGORIES_TABLE_TRANSLATION_KEY}.url`,
    headerClass: `${BASE_HEADER_CLASS} ${BASE_HEADER_CLASS}--url`,
    cellClass: BASE_CELL_CLASS,
  },
  {
    name: CategoriesEnumList.LEVEL,
    label: `${CATEGORIES_TABLE_TRANSLATION_KEY}.level`,
    headerClass: `${BASE_HEADER_CLASS} ${BASE_HEADER_CLASS}--level`,
    cellClass: BASE_CELL_CLASS,
  },
  {
    name: CategoriesEnumList.VISIBILITY,
    label: `${CATEGORIES_TABLE_TRANSLATION_KEY}.visibility`,
    headerClass: `${BASE_HEADER_CLASS} ${BASE_HEADER_CLASS}--visibility`,
    cellClass: BASE_CELL_CLASS,
  },
  {
    name: CategoriesEnumList.NUMBER_PRODUCTS,
    label: `${CATEGORIES_TABLE_TRANSLATION_KEY}.numberOfProducts`,
    headerClass: `${BASE_HEADER_CLASS} ${BASE_HEADER_CLASS}--numberOfProducts`,
    kind: 'numberProducts',
  },
  {
    name: CategoriesEnumList.ACTIONS,
    label: `${CATEGORIES_TABLE_TRANSLATION_KEY}.actions`,
    headerClass: `${BASE_HEADER_CLASS} ${BASE_HEADER_CLASS}--actions`,
    kind: 'actions',
  },
];

export const CATEGORIES_MODAL_OPTIONS = {
  width: '808px',
  maxWidth: '95vw',
  panelClass: 'no-radius-dialog',
};
